module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1XUxtT/tc-custom/9780369711090.jpg?1743828921007",
      "alt": "This image is the cover for the book Enthralled by Her Enemy's Kiss"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Enthralled by Her Enemy's Kiss\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('i', [_vm._v("From feuding families")])]), _c('br'), _c('br'), _c('i', [_vm._v("…To an unlikely alliance?")]), _c('br'), _c('br'), _vm._v(" Jane Deighton’s sister has eloped with the son of her family’s sworn enemy! Determined to retrieve her at all costs, Jane is even willing to ask the man’s formidable older brother, Lord Francis Randolph, for help. On their journey to find the runaways, Jane and Francis reluctantly start gravitating toward one another—culminating in one sinful kiss! Their families have been feuding for years, yet Jane can’t help herself from being drawn to Francis’s forbidden touch…"), _c('br'), _c('br'), _c('b', [_vm._v("From Harlequin Historical: "), _c('i', [_vm._v("Your romantic escape to the past.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Helen Dickson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Helen Dickson lives in South Yorkshire with her retired farm manager husband. On leaving school she entered the nursing profession, which she left to bring up a young family. Having moved out of the chaotic farmhouse, she has more time to indulge in her favourite pastimes. She enjoys being outdoors, travelling, reading and music. An incurable romantic, she writes for pleasure. It was a love of history that drove her to writing historical romantic fiction.  ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0